import { useEffect, useRef, useState } from 'react';
import { useSounds } from '../utils/useSounds';

export const useRatchet = () => {
    const { clickSound } = useSounds();
    const [isRatchet, setIsRatchet] = useState(false);
    const animationFrameRef = useRef(0);
    const startTimeRef = useRef(0);
    const prevProgressRef = useRef(0);

    const duration = 2600;

    const ease = (t: number): number => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };

    const animate = (timestamp: number) => {
        if (startTimeRef.current === 0) {
            startTimeRef.current = timestamp;
        }

        const elapsed = timestamp - startTimeRef.current;
        const newProgress = Math.min(1, elapsed / duration);

        const easedProgress = ease(newProgress);

        // Вызываем clickSound(), если easedProgress увеличился на определенный шаг
        if (easedProgress - prevProgressRef.current >= 0.02) {
            clickSound();
            prevProgressRef.current = easedProgress;
        }

        if (newProgress < 1) {
            animationFrameRef.current = requestAnimationFrame(animate);
        } else {
            // Сброс состояния после завершения анимации
            startTimeRef.current = 0;
            prevProgressRef.current = 0;
        }
    };

    useEffect(() => {
        if (isRatchet) {
            startTimeRef.current = 0;
            prevProgressRef.current = 0;
            animationFrameRef.current = requestAnimationFrame(animate);
        }

        return () => {
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, [isRatchet]);

    return { setIsRatchet };
};